import TagManager from '@sooro-io/react-gtm-module';
import { CookieHub } from 'react-cookiehub';

import { getAwsRum, initializeAwsRum } from './rum';

// NOTE: This tracker does not set cookie, so do not require cookie consent.
export const initializeGoogleTagManager = () => {
  const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
  if (!gtmId) {
    console.info(
      'Google Tag Manager is not initialized because GTM ID is not configured.'
    );
    return;
  }

  TagManager.initialize({ gtmId });
};

export const initializeCookieHub = () => {
  if (
    import.meta.env.DEV &&
    import.meta.env.VITE_DEV_INITIALIZE_COOKIEHUB != 'true'
  ) {
    console.info(
      "CookieHub is not initialized because the app is in development and VITE_DEV_INITIALIZE_COOKIEHUB is not 'true'."
    );
    return;
  }
  const domainCode = import.meta.env.VITE_COOKIEHUB_DOMAIN_CODE;
  if (!domainCode) {
    console.warn(
      'CookieHub is not initialized because domain code is not configured.'
    );
    return;
  }

  CookieHub.initialize(import.meta.env.VITE_COOKIEHUB_DOMAIN_CODE, {
    onAllow: category => {
      if (category === 'analytics') {
        initializeAwsRum();
      }
    },
    onRevoke: category => {
      if (category === 'analytics') {
        const rum = getAwsRum();
        if (rum) {
          rum.disable();
        }
      }
    },
    debug: import.meta.env.DEV
  });
};
